const prefillNumberInputs = (data, categories, startingDate) => {
  const startDate = new Date(startingDate);

  if (isNaN(startDate.getTime())) {
    return [];
  }

  const getMonthIndex = (recordMonth, startDate) => {
    const recordDate = new Date(recordMonth);
    if (isNaN(recordDate.getTime())) {
      return -1;
    }

    const monthsDiff =
      (recordDate.getFullYear() - startDate.getFullYear()) * 12 +
      (recordDate.getMonth() - startDate.getMonth());
    return monthsDiff >= 0 ? monthsDiff : -1;
  };

  const defaultCategories = categories.filter(cat => cat.default_value);
  const customCategories = categories.filter(cat => cat.custom_value);

  const defaultNumberInputs = defaultCategories.map(category => {
    const id = category.id;
    const monthArray = Array(12).fill(0);

    const dataItems = data.filter(item => item.user_income_heads_id === id);

    dataItems.forEach(item => {
      item.data.forEach(record => {
        const monthIndex = getMonthIndex(
          new Date(record.month).toISOString(),
          startDate
        );
        if (monthIndex >= 0 && monthIndex < 12) {
          monthArray[monthIndex] = record.amount || 0;
        }
      });
    });

    return monthArray;
  });

  const customNumberInputs = customCategories.map(category => {
    const id = category.id;
    const monthArray = Array(12).fill(0);

    const dataItems = data.filter(item => item.custom_income_heads_id === id);

    dataItems.forEach(item => {
      item.data.forEach(record => {
        const monthIndex = getMonthIndex(
          new Date(record.month).toISOString(),
          startDate
        );
        if (monthIndex >= 0 && monthIndex < 12) {
          monthArray[monthIndex] = record.amount || 0;
        }
      });
    });

    return monthArray;
  });

  return [...defaultNumberInputs, ...customNumberInputs];
};

export default prefillNumberInputs;
